import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readIndustrySelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 산업 구분 셀렉트박스
 * @param props
 * @returns
 */
export const useReadIndustrySelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readIndustrySelect"],
        queryFn: async () => await readIndustrySelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
